/**
 * Adapter between the build-time `featuredStudyPlans.generated.json`
 * manifest and the `studyPlan` shape `StudyPlanDetailsModal` expects.
 *
 * Manifest entry (from `GET /featured_study_plan/manifest`):
 *   { lesson_plan_id, subject, emoji, goal, description, lessons, share_token }
 *
 * Modal shape (`StudyPlanDetailsModal` props.studyPlan):
 *   { subject, title, image, description, lessons, share_token, ... }
 *
 * The manifest is generated at build time (see
 * `lf_fe/scripts/fetch_featured_study_plans.js`); the file is
 * gitignored so this module imports it through a try/catch so unit
 * tests / first-time clones don't break.
 */

let manifest;
try {
  // eslint-disable-next-line global-require
  manifest = require("./featuredStudyPlans.generated.json");
} catch (e) {
  manifest = { plans: [] };
}

function manifestToStudyPlan(entry) {
  if (!entry || typeof entry !== "object") return null;
  return {
    subject: entry.subject,
    title: entry.goal || entry.subject,
    image: entry.emoji || "",
    description: entry.description || entry.goal || "",
    lessons: Array.isArray(entry.lessons) ? entry.lessons : [],
    share_token: entry.share_token || null,
    lesson_plan_id: entry.lesson_plan_id || "",
  };
}

/**
 * Return entries in `pillDisplay` insertion order. Entries whose
 * subject is missing from the lookup are filtered out so renaming a
 * subject in the seed without updating `pillDisplay` makes the plan
 * invisible (rather than rendering an unstyled pill in an arbitrary
 * position).
 */
function loadFeaturedPlans(pillDisplay, subjectOrder = Object.keys(pillDisplay)) {
  const plans = Array.isArray(manifest.plans) ? manifest.plans : [];
  const bySubject = new Map();
  for (const entry of plans) {
    const adapted = manifestToStudyPlan(entry);
    if (adapted && adapted.subject) bySubject.set(adapted.subject, adapted);
  }

  const out = [];
  for (const subject of subjectOrder) {
    const plan = bySubject.get(subject);
    const display = pillDisplay[subject];
    if (plan && display) out.push({ plan, display });
  }
  return out;
}

module.exports = { loadFeaturedPlans, manifestToStudyPlan };
module.exports.default = loadFeaturedPlans;
